export enum TimelineItemType {
  PHASE_BLOCK = 'phaseBlock',
  PHASE_BULLET = 'phaseBullet',
  PHASE_BUTTON = 'phaseButton',
  MILESTONE_BULLET = 'milestoneBullet',
  MILESTONE = 'milestone',
  MILESTONE_BUTTON = 'milestoneButton'
}
